import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import OpenNetworkLogBasicInfoComponent from './open-network-log-basic-info.component';
import ManagementOpenNetworkLogs from '../containers/open-network-logs';

export const OpenNetworkLogComponent = ({
  showResults, handleInnerFormChange, selectOpenNetworkLogs, handleFormSubmit, handleClearFilter, actionList,
  dateRangesList, domainList
}: any) => {

  const tabItems = [
    {
      id: 1,
      title: 'Open Network Log Search',
      component: <OpenNetworkLogBasicInfoComponent
        selectOpenNetworkLogs={selectOpenNetworkLogs}
        handleInnerFormChange={handleInnerFormChange}
        actionList={actionList}
        dateRangesList={dateRangesList}
        domainList={domainList}
      />,
      isVisible: true,
    }
  ]

  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">

      <TabContainer tabItems={tabItems} />

      <div className='flex w-full justify-end items-end'>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleClearFilter}
          type="submit"
        >
          Clear Filters
        </button>
        <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          onClick={handleFormSubmit}
          type="submit"
        >
          Submit
        </button>
      </div>
      {showResults && (
        <ManagementOpenNetworkLogs
          searchData={selectOpenNetworkLogs}
        />
      )}
    </div>
  );
};

export default OpenNetworkLogComponent;
